import { TextInput } from 'react-native'

import { styled } from '~/core/styled'

import { convertPercentageToNumber } from '~/utils'

export const Value = styled(TextInput, theme => {
  return {
    base: {
      flex: 1,
      height: '100%',

      fontFamily: theme.fontFamily.regular,
      color: theme.colorTextNeutralDefault,
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
    },
    variants: {
      size: {
        md: {
          fontSize: theme.fontSizeThreepulse,
        },
        ml: {
          fontSize: theme.fontSizeThreeandhalfpulse,
        },
        lg: {},
        xl: {},
      },
      isFilled: {
        true: {
          color: theme.colorTextNeutralAlternative,
        },
      },
      isDisabled: {
        true: {
          color: theme.colorTextNeutralDisabled,
          opacity: theme.opacityOpaque,
        },
      },
      isReadOnly: {
        true: {
          color: theme.colorTextNeutralReadonly,
        },
      },
    },
  }
})
